/**
 * Service — base de tous les services HA (ESM, ha/440).
 *
 * Conversion namespace→ESM. L'interface `IWebPageService` reste exportée.
 * L'héritage `extends HAObject` est résolu au top-level → import direct.
 */

import { HAObject } from "../HAObject";

/**
 * Contrat exposé aux services internes (App, User…) pour piloter la navigation.
 * Implémenté par WebPage.getBaseApi() — ne jamais dépendre de WebPage directement.
 */
export interface IWebPageService {
    isActive: (id: string) => boolean;
    reloadApp: (data?: any) => void;
    removeApp: (id: string) => void;
    removeCurrentApp: () => void;
    reloadNav: () => void;
    reloadPreviousApp: () => void;
    replaceAppId: (id: any, newId: any) => void;
    setMainApp: (data: any) => void;
    showApp: (data: any) => void;
    showAppMenu: (data: any) => void;
    showModal: (data: any) => void;
    showFSApp: (app: any) => void;
    showPreviousApp: () => void;
    toggleQMenu: () => void;
    setQMenu: (qmenu: () => void) => void;
    subscribeToAppInfo: (func: (info: Map<string, any>) => void) => string[];
    unsubscribeToAppInfo: (subscriptionId: string) => void;
    toggleApp: (data: any) => void;
    removeAll: () => void;
}

/**
 * Classe de base de tous les services HA.
 * Hérite de HAObject : l'état est stocké dans une Map interne accessible via get/addToData.
 * Les services sont instanciés avec un objet { services: {...} } pour accéder aux dépendances
 * via this.getService("ha.service.xxx").
 */
export class Service extends HAObject {
}
